import Input from './src/input.vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpInput = withInstall(Input)
export default EpInput
export * from './src/input'

